import React, { useState, useEffect, useMemo } from 'react';

export default function ProductForm({ onSave, initialData, isLoading, onCancel }) {
    const defaultState = useMemo(() => ({ name: '', sizes: '', colors: '' }), []);
    const [formData, setFormData] = useState(defaultState);

    useEffect(() => {
        if (initialData) {
            setFormData({
                name: initialData.name || '',
                sizes: Array.isArray(initialData.sizes) ? initialData.sizes.join(', ') : '',
                colors: Array.isArray(initialData.colors) ? initialData.colors.join(', ') : '',
            });
        } else {
            setFormData(defaultState);
        }
    }, [initialData, defaultState]);
    
    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700">Nombre del Producto</label>
                <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="Ej: Playera Oversize Adulto - Hombre" required className="input-field mt-1"/>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Tallas Disponibles</label>
                <input type="text" value={formData.sizes} onChange={e => setFormData({...formData, sizes: e.target.value})} placeholder="Ej: S, M, L, XL" required className="input-field mt-1"/>
                <p className="text-xs text-gray-500 mt-1">Separar con comas.</p>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Colores Disponibles</label>
                <input type="text" value={formData.colors} onChange={e => setFormData({...formData, colors: e.target.value})} placeholder="Ej: Blanco, Negro, Rojo" required className="input-field mt-1"/>
                <p className="text-xs text-gray-500 mt-1">Separar con comas.</p>
            </div>
            <div className="flex justify-end pt-4 border-t">
                <button type="button" onClick={onCancel} className="btn-secondary mr-3">Cancelar</button>
                <button type="submit" disabled={isLoading} className="btn-primary">{isLoading ? "Guardando..." : "Guardar Producto"}</button>
            </div>
        </form>
    );
}
